import { render } from "./CustomersList.vue?vue&type=template&id=2e1326d4&scoped=true"
import script from "./CustomersList.vue?vue&type=script&lang=js"
export * from "./CustomersList.vue?vue&type=script&lang=js"

import "./CustomersList.vue?vue&type=style&index=0&id=2e1326d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1326d4"]])

export default __exports__